/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../../shared/types/__generated__/graphql"
import { ProjectPreviewFragmentDoc } from "../../projects/graphql/fragments.generated"
import { TeamMemberFragmentDoc } from "../../team-members/graphql/fragments.generated"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type TeamPreviewFragment = {
  __typename: "Team"
  id: string
  name: string
  description?: string | null
}

export type TeamAttributesFragment = {
  __typename: "Team"
  createdAt: string
  updatedAt: string
  id: string
  name: string
  description?: string | null
}

export type TeamRelationshipsFragment = {
  __typename: "Team"
  memberships: Array<{
    __typename: "TeamMember"
    id: string
    role: string
    invitedAt?: string | null
    invitationAcceptedAt?: string | null
    invitationAccepted: boolean
    createdAt: string
    updatedAt: string
    user?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
  }>
  projects?: Array<{
    __typename: "Project"
    id: string
    title: string
    phase?: {
      __typename: "ProjectPhase"
      id: string
      value: string
      label: string
    } | null
  }> | null
}

export type TeamFragment = {
  __typename: "Team"
  createdAt: string
  updatedAt: string
  id: string
  name: string
  description?: string | null
  memberships: Array<{
    __typename: "TeamMember"
    id: string
    role: string
    invitedAt?: string | null
    invitationAcceptedAt?: string | null
    invitationAccepted: boolean
    createdAt: string
    updatedAt: string
    user?: {
      __typename: "User"
      id: string
      name?: string | null
      email: string
      createdAt: string
      updatedAt: string
    } | null
  }>
  projects?: Array<{
    __typename: "Project"
    id: string
    title: string
    phase?: {
      __typename: "ProjectPhase"
      id: string
      value: string
      label: string
    } | null
  }> | null
}

export const TeamPreviewFragmentDoc = gql`
  fragment TeamPreview on Team {
    id
    name
    description
  }
`
export const TeamAttributesFragmentDoc = gql`
  fragment TeamAttributes on Team {
    ...TeamPreview
    createdAt
    updatedAt
  }
  ${TeamPreviewFragmentDoc}
`
export const TeamRelationshipsFragmentDoc = gql`
  fragment TeamRelationships on Team {
    memberships @type(name: "TeamMember") {
      ...TeamMember
    }
    projects @type(name: "Project") {
      ...ProjectPreview
    }
  }
  ${TeamMemberFragmentDoc}
  ${ProjectPreviewFragmentDoc}
`
export const TeamFragmentDoc = gql`
  fragment Team on Team {
    ...TeamAttributes
    ...TeamRelationships
  }
  ${TeamAttributesFragmentDoc}
  ${TeamRelationshipsFragmentDoc}
`
